import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { User } from '../../../models/identity/user.model';
import { ChatFacadeService } from '../../services/chat-facade.service';
import { Message } from '../../type/message.type';

@Component({
    selector: 'app-conversation',
    templateUrl: './conversation.component.html',
    styleUrls: ['./conversation.component.scss'],
})
export class ConversationComponent implements OnInit, AfterViewChecked {
    @Input() messages: Message[] = [];
    @Input() targetUser: User | null = null;
    @Input() authenticatedUserId: string = '';

    @Output() messageSent = new EventEmitter<string>();

    @ViewChild('messageInput') messageInput!: ElementRef<HTMLTextAreaElement>;

    newMessage: string = '';

    get allMessages(): Message[] {
        const messages = this.messages || [];
        return messages;
    }

    constructor(private readonly chatFacade: ChatFacadeService) {}

    ngOnInit(): void {
        this.chatFacade.targetUser$.subscribe((user) => {
            if (user) {
                setTimeout(() => this.messageInput?.nativeElement.focus(), 0);
            }
        });
    }

    ngAfterViewChecked(): void {
        this.scrollToBottom();
    }

    sendMessage(): void {
        if (!this.newMessage.trim()) return;

        this.messageSent.emit(this.newMessage);
        this.newMessage = '';
    }

    onInputKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    private scrollToBottom(): void {
        const container = document.getElementById('message-list');
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }
}
